import { lazy } from 'react';

export const LazyMicrosoftSendSignaturePage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--microsoft-send-signature-page" */ './microsoft-send-signature-page'
    ),
);
